import React, { } from "react";
import HelpWindow from "./HelpWindow";
import { Typography } from "@mui/material";
import { Help_BuiltInAccounts, Help_Crumbs } from "./Help_General";

export const Help_FinancialGrid = () => {
    return (
        <HelpWindow title="Financial Grid" >
            <Typography variant="body1" gutterBottom>
                This is the heart of a scenario.  The grid shows all the accounts over time. <br />
                To reveal hidden accounts click the '{'>'}' beside some of the headings (like 'Annual {'>'}') <br />



                <b>Columns</b><br />
                <Help_BuiltInAccounts />


                <br />
                <b>Cents:</b> Account values are also in dollars only. CPP,OAS,Tax Calculations are completed in dollars+cents since there are many small calculations, when each is applied to its account it is then truncated to dollars, any subsequent transfers to other accounts is also then in dollars. Other calculations like returns are truncated to the dollar. <br />


                <b>Value Decorations</b><br />
                <li><i>Purple: </i> There are User Input entries in these cells.</li>
                <li><i>Light Purple: </i> These are propagated directly from a UserInputCell  generally an UpToAge based cell from a userInput.</li>
                <li><i>Orange/Red: </i> These are cells that should be looked at.  For example in the Tax/Provincial and Tax/Federal columns these indicate that non-refundable credits remain unused.</li>
                <li><i>Black: </i> These are calculated values from other accounts.</li>
                <li><i>Underline: </i> These are cells that you could enter a UserInput value.</li>
                <li><i>Purple Background: </i> These are cells where there is a shortfall (value should not be negative)  This can happen in a situation where there is not enough cash or investments (or the rules are too restrictive) to cover the annual expenses.</li>


                <Help_Crumbs />



            </Typography>
        </HelpWindow >
    )
}

export const Help_IncomeGrid = () => {
    return (
        <HelpWindow title="Income/Decumulation Grid" >
            <Typography variant="body1" gutterBottom>
            </Typography>
        </HelpWindow>
    )
}


export const Help_CppGrid = () => {
    return (
        <HelpWindow title="CPP Grid" >
            <Typography variant="body1" gutterBottom>
                <b>Calculations</b>
                <span></span>
                <b>(Year $):</b> When looking at (Year $) Only the last 4 columns (Benefit, Scaled, Survivor and Total) change. Since most of the calculations are normally in the past and it makes sense to always use (Real $) to show those.
                <br />
                <b>Cents:</b> CPP calculations are completed with dollars+cents for accuracy, however they are displayed truncated to dollars.<br />
                <br />
                <b>Types of CPP</b><li><i>Basic</i> is the the benefit that replaces 25% of the pensionable earnings that is the normal CPP before 2019.</li>
                <li><i>1st</i> is the benefit that raises the replacement rate from 25% to 33% of pensionable earnings for YMPE.  This replacement starts in 2019 and increased the contribution rate by 1%.</li>
                <li><i>2nd</i> is the benefit that replaces 33% of the additional pensionable earnings, These are the earnings between YMPE and YAMPE.  This raises in pensionable earnings is 7% in 2023 and 14% in 2024 of the standard pensionable earnings.</li>
                <br />
                <b>Contributions:</b> These are the contributions from your employment that pertain to each of the CPP types.<br />
                <b>Pensionable Earnings:</b> These are the maximum pensionable earnings, Unadjusted Pensionable Earnings (UPE) are for Basic & 1st. Additional UPE (AUPE) are for 2nd.<br />
                <br />
                <b>Calculations</b><br />
                <b>Basic</b>
                <li><b>% UPE:</b> simply the Basic Contributions / UPE</li>
                <li><b>AYMPE:Est:</b> Estimate of the Average Yearly Maximum Pensionable Earnings in the 5 years before receiving your CPP pension.</li>
                <li><b>:</b></li>
                <li><b>APE:</b>Adjusted Pensionable Earnings is the %UPE * AYMPE. </li>
                <li><b>TAPE:</b>Total APE is the cumulative APE.</li>
                <li><b>Months:</b>how many months apply to to the total, this is a cumulative total</li>
                <li><b>Drop:</b> Denote if the year is dropped from the total. These should be the lowest %UPE years.</li>
                <li><b>NDM:</b> The number of dropped months in the year</li>
                <li><b>PDM:</b> The personal dropped months related to child rearing and disability as input.</li>
                <b>1st</b>
                {/* <li><b>Drop:</b> The years is dropped from 1st</li> */}
                <li><b>FAAPE:</b> First Additional Adjusted Pensionable Earnings.  From 2019 to 2023 this is phased in, after that it should be be the same as APE.</li>
                <li><b>FTAAPE:</b>Total FAAPE is the cumulative FAAPE over the best 40 years.</li>
                <li><b>C.FAMPE:</b>First Additional Monthly Pensionable Earnings (FTAAPE/480)*0.0833, this is cumulative</li>
                {/* <li><b>C.Months:</b> The number on months for FTAAPE</li> */}
                <b>2nd</b>
                <li><b>SAAPE:</b> Second Additional Adjusted Pensionable Earnings.  These are the additional Pensionable Earnings </li>
                <li><b>STAAPE:</b>Total SAAPE is the cumulative SAAPE over the best 40 years.</li>
                <li><b>C.SAMPE:</b>Second Additional Monthly Pensionable Earnings (STAAPE/480)*.333, this is cumulative</li>
                {/* <li><b>C.Months:</b> The number on months for STAAPE</li> */}
                <br />
                <b>Benefits</b><br />
                <b>Basic</b>

                <li><b>Monthly:</b>(TAPE * .25) / Basic.Months</li>
                <li><b>Yearly:</b> Monthly * 12</li>
                <li><b>%Basic:</b> how much of the basic CPP benefit this qualifies for.  Each year you have UPE this goes up until it hits 100%</li>
                <b>1st</b>
                <li><b>Monthly:</b>the same as C.FAMPE</li>
                <li><b>Yearly:</b>Monthly * 12</li>
                {/* <li><b>%Basic:</b> how much of the 1st CPP benefit this qualifies for. </li> */}
                <b>2nd</b>
                <li><b>Monthly:</b>the same as C.SAMPE</li>
                <li><b>Yearly:</b> Monthly * 12</li>
                {/* <li><b>%Basic:</b> how much of the basic CPP benefit this qualifies for.  Each year you have UPE this goes up until it hits 100%</li> */}

                <b>Personal Total</b> The yearly benefit total<br />
                <b>Scaled</b> The yearly benefit scaled based on when the benefit is received.  Reduced 0.6% for each month before 65. Increases 0.7% for each month after 65<br />
                <b>Survivor</b>Any benefit based on the passing of the spouse.<br />
                <b>Total</b>Total Payment<br />
                <a href="https://open.canada.ca/data/en/dataset/f8ec9eb8-62d1-487b-83ff-4c407b6cb227" target="_blank" rel="noopener noreferrer">CPP Data</a><br />

                <a href="https://www.canada.ca/en/department-finance/news/2016/09/backgrounder-canada-pension-plan-cpp-enhancement.html" target="_blank" rel="noopener noreferrer">CPP Enhancement Background</a><br />


            </Typography>
        </HelpWindow>
    )
}
export const Help_OasGrid = () => {
    return (
        <HelpWindow title="OAS Grid" >
            <Typography variant="body1" gutterBottom>
                <li><b>% Max @ 65:</b> This is the amount of your benefit compared to the standard monthly benefit if you had taken OAS @ 65, and if you have elected to defer your OAS past 65 this will be up to 136%.  Of course any clawback will reduce those amounts.</li>

                <b>Quarterly Changes:</b> OAS benefits changer every quarter (Jan, Apr, Jul, Sep), We use the Jan and July values, since we have to calculate in July based on the income from the previous tax year. For the current and future years we use the latest available value even if its not Jan/Jul.<br />
                <b>Cents:</b> OAS calculations are completed with dollars+cents for accuracy, however they are displayed truncated to dollars.<br />

                <br />
                <a href="https://open.canada.ca/data/en/dataset/ff1e4882-685c-4518-b741-c3cf9bb74c3e" target="_blank" rel="noopener noreferrer">OAS Data</a><br />
                <a href="https://www.canada.ca/en/services/benefits/publicpensions/cpp/old-age-security/recovery-tax.html" target="_blank" rel="noopener noreferrer">OAS Recovery</a>

            </Typography>
        </HelpWindow >
    )
}


export const Help_GisGrid = () => {
    return (
        <HelpWindow title="GIS Grid" >
            <Typography variant="body1" gutterBottom>
                <b>Quarterly Changes:</b> GIS benefits changer every quarter (Jan, Apr, Jul, Sep), We use the Jan and July values, since we have to calculate in July based on the income from the previous tax year. For the current and future years we use the latest available value even if its not Jan/Jul.<br />
                <b>Cents:</b> GIS calculations are completed with dollars+cents for accuracy, however they are displayed truncated to dollars.<br />

                <br />
                <a href="https://open.canada.ca/data/en/dataset/dfa4daf1-669e-4514-82cd-982f27707ed0" target="_blank" rel="noopener noreferrer">GIS Data</a><br />
                <a href="https://www.canada.ca/en/employment-social-development/programs/old-age-security/reports/oas-toolkit.html" target="_blank" rel="noopener noreferrer">GIS examplesGisViewddddddd</a>

            </Typography>
        </HelpWindow >
    )
}

export const Help_GovbGrid = () => {
    return (
        <HelpWindow title="Government Benefits Grid" >
            <Typography variant="body1" gutterBottom>

                <br />
                <a href="https://www.canada.ca/en/revenue-agency/services/forms-publications/publications/rc4210/gst-hst-credit.html" target="_blank" rel="noopener noreferrer">GST Credit</a><br />
                <a href="https://www.canada.ca/en/revenue-agency/services/child-family-benefits/canada-carbon-rebate/how-much.html" target="_blank" rel="noopener noreferrer">Canada Carbon Rebate</a>

            </Typography>
        </HelpWindow >
    )
}


export const Help_GridChart = () => {
    return (
        <HelpWindow title="Chart Grid" >
            <Typography variant="body1" gutterBottom>
                Help for grid generated from charts
            </Typography>
        </HelpWindow >
    )
}